var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1082 5.26418H12.9291L9.64663 1.38492C9.46863 1.17309 9.25681 1.00512 9.02346 0.890765C8.79011 0.776407 8.53987 0.717931 8.28726 0.718728H1.95433C1.4443 0.718728 0.955153 0.958175 0.594506 1.38439C0.233859 1.81061 0.03125 2.38869 0.03125 2.99145V23.5341C0.0322039 24.1134 0.227433 24.6686 0.574158 25.0781C0.920883 25.4876 1.39083 25.718 1.88101 25.7187H23.2151C23.6966 25.718 24.1582 25.4916 24.4986 25.0893C24.8391 24.6869 25.0306 24.1414 25.0312 23.5724V7.53691C25.0312 6.93414 24.8286 6.35607 24.468 5.92985C24.1073 5.50363 23.6182 5.26418 23.1082 5.26418ZM1.95433 2.99145H8.28726L10.2103 5.26418H1.95433V2.99145Z",
    fill: "#004D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.c17ab4b2400fafc894cc2c7b2ed37bdf.svg";
export { ForwardRef as ReactComponent };